export function LocalServer(){
    // return 'https://acms.dbmsuite.com/';
    // return 'http://127.0.0.1:8000/';
    return 'https://acmstest.dbmsuite.com/';
    // return 'https://akshayakerala.com/';
}